import { auth } from '../services/firebaseAuth';

/**
 * The signed-in user on the app's initialized Firebase Auth instance,
 * after persistence restore. A missing currentUser before that restore
 * is not a signed-out session. Returns null once auth is ready and
 * nobody is signed in.
 */
export async function resolvedAuthUser() {
  if (auth.currentUser) return auth.currentUser;
  if (typeof auth.authStateReady === 'function') {
    await auth.authStateReady();
  }
  return auth.currentUser || null;
}
